import { Injectable, Inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AppConfigUtil } from "../../../utils/app-config.util";
import { ResponseError } from "../error/response.error";
import { WebFetchErrorHandler } from "../error/handler/web-fetch-error.handler";
import { AppUtil } from "../../../utils/app.util";

import {
	HttpClient,
	HttpRequest,
	HttpParams,
	HttpHeaders,
	HttpResponse
} from "@angular/common/http";

/**
 * Rest service client to make network rest calls, intercepts request/response and handles client and network errors.
 */
@Injectable()
export abstract class RestClient {
	private webFetchErrorHandler: WebFetchErrorHandler = null;
	private dynamicUri: string = null;
	private dynamicBaseUrl: string = null;
	private dynamicTimeout: number = null;
	private dynamicHeaders: number = null;

	public constructor(protected http: HttpClient) {
		this.webFetchErrorHandler = new WebFetchErrorHandler();
	}

	private getServiceId(): string {
		return;
	}

	private getDefaultHeaders(): Object {
		return;
	}

	private getBaseUrl(): string {
		AppUtil.log(
			"RestClient : getBaseUrl() ===> AppConfigUtil.getProperties() ===> %o",
			AppConfigUtil.getProperties()
		);
		return AppConfigUtil.getProperties().webApiUrl;
	}

	public setDynamicTimeout(timeout: number) {
		AppUtil.log(
			"RestClient : setDynamicTimeout() ===> timeout ===> %o",
			timeout
		);
		this.dynamicTimeout = timeout;
	}

	public getDynamicTimeout(): number {
		AppUtil.log(
			"RestClient : getDynamicTimeout() ===> this.dynamicTimeout ===> %o",
			this.dynamicTimeout
		);
		return this.dynamicTimeout;
	}

	public setDynamicBaseUrl(baseUrl: string) {
		this.dynamicBaseUrl = baseUrl;
	}

	public getDynamicBaseUrl(): string {
		return this.dynamicBaseUrl;
	}

	public setDynamicUri(uri) {
		AppUtil.log("RestClient : setDynamicUri() ===> uri ===> %o", uri);
		this.dynamicUri = uri;
	}

	public getDynamicUri(): string {
		AppUtil.log(
			"RestClient : getDynamicUri() ===> this.dynamicUri ===> %o",
			this.dynamicUri
		);
		return this.dynamicUri;
	}

	public requestInterceptor(request: HttpRequest<any>): HttpRequest<any> {
		AppUtil.log(
			"RestClient :ShamredModule : requestInterceptor() ===> %o",
			request
		);
		if (
			request &&
			request.serializeBody() &&
			typeof request.serializeBody() === "string"
		) {
			let requestBody: string | any = request.serializeBody();
			try {
				requestBody = JSON.parse(requestBody);
				Object.assign(request);
			} catch (err) {
				//unable to parse json string.
				AppUtil.error(
					"Error in RestClient:requestInterceptor's body: " +
						requestBody +
						" Error: " +
						err
				);
			}
		}
		return request;
	}
	public responseInterceptor(
		response: Observable<HttpResponse<any>>
	): Observable<HttpResponse<any>> {
		AppUtil.log(
			"RestClient :SharedModule : responseInterceptor() ===> %o",
			response
		);
		return response;
	}

	private handleRestServiceError(
		responseError: HttpResponse<any> | any
	): Observable<any> {
		AppUtil.log("RestClient : handleRestServiceError() ===> %o", responseError);
		return this.webFetchErrorHandler.handleWebFetchError(responseError);
	}

	// To Extract/Process API Non Observable response.
	public getApiResponse(apiResponse: any) {
		AppUtil.log("RestClient :getApiResponse() ===> %o", apiResponse);
	}
}
